import { render, staticRenderFns } from "./BroadcastPurchase.vue?vue&type=template&id=2dbede3d&scoped=true"
import script from "./BroadcastPurchase.vue?vue&type=script&lang=js"
export * from "./BroadcastPurchase.vue?vue&type=script&lang=js"
import style0 from "./BroadcastPurchase.vue?vue&type=style&index=0&id=2dbede3d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbede3d",
  null
  
)

export default component.exports